<template>
  <v-card>
    <!-- Création des onglets (navigation) -->
    <v-tabs
      v-model="exampleTab"
      background-color="secondary accent-4"
      dark
      grow
    >
      <v-tab key="#tab-csv">
        CSV
      </v-tab>

      <v-tab key="#tab-xlsx">
        XLSX (Excel)
      </v-tab>
    </v-tabs>

    <!-- Création des onglets (contenu) -->
    <v-tabs-items v-model="exampleTab">
      <v-tab-item key="#tab-csv">
        <v-card-title>
          <span class="headline secondary--text">CSV</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <span v-html="$t('TagsUpdateExample.CSV.Text')" />

            <v-card flat>
              <v-card-title />
              <v-card-text>
                <span v-html="$t('TagsUpdateExample.CSV.Example')" />
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>
      </v-tab-item>
      <v-tab-item key="#tab-xlsx">
        <v-card-title>
          <span class="headline secondary--text">XLSX</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-container>
              <span v-html="$t('TagsUpdateExample.XLSX.Text')" />

              <v-card flat>
                <v-card-title />
                <v-card-text>
                  <v-img :src="require('../../../../assets/' + $t('TagsUpdateExample.XLSX.Example'))" />
                </v-card-text>
              </v-card>
            </v-container>
          </v-container>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>

    <v-card-actions
      class="justify-center"
    >
      <v-btn
        color="primary"
        @click="$emit('set-example', false, formattedExampleTab)"
      >
        {{ $t('TagsUpdateExample.Btn.Validate') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'TagsUpdateExample',

    /* Paramètres */
    props: {
      tab: {
        type: String,
        default: undefined,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        exampleTab: undefined,
        formats: {
          csv: 0,
          xlsx: 1,
        },
        tabs: ['csv', 'xlsx'],
      }
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      formattedExampleTab: function () {
        if (typeof this.exampleTab !== 'number') {
          return this.exampleTab
        } else {
          return this.tabs[this.exampleTab]
        }
      },
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      tab: {
        handler: function (newVal) {
          this.getOrderIndex(newVal)
        },
        // Permet d'exécuter le watcher à la création du composant
        immediate: true,
      },
    },

    /* Fonctions internes */
    methods: {
      // Traduit la chaîne de caractère de l'onglet en numéro d'onglet
      getOrderIndex: function (val) {
        this.tabs.forEach((item, i) => {
          if (val === item) {
            this.exampleTab = i
          }
        })
      },
    },
  }
</script>
